import { createTracker } from '@open-measure/web'
import { ga4 } from '@open-measure/dest-ga4'

export const tracker = createTracker({
  destinations: [
    ga4({ measurementId: 'G-1QC37K2YSB' }),
  ],
})
